import { forwardRef, Ref, type SVGProps } from 'react';

const SvgArrowRightIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 20"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="m9 2 8 8-8 8M16 10H1"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgArrowRightIcon);
export default ForwardRef;
